import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-export-btn',
  templateUrl: './export-btn.component.html',
  styleUrls: ['./export-btn.component.scss']
})
export class ExportBtnComponent implements OnInit {

  constructor() { }
  @Input() type: string;
  ngOnInit(): void {
  }

  public downloadAsPDF() {
    const data = document.getElementById(this.type);
    html2canvas(data, {}).then(canvas => {
      const imgWidth = 210;
      const pageHeight = 295;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight;
      const contentDataURL = canvas.toDataURL('image/png')
      const doc = new jsPDF('p', 'mm');
      let position = 0;

      doc.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save( `${this.type}.pdf`);
    });
  }
}
